import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d771361c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-logo" }




export default /*#__PURE__*/_defineComponent({
  __name: 'LogoProject',
  props: {
  titleSize: {
    type: String,
    default: "lg",
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: { name: 'home' } }, {
      default: _withCtx(() => [
        _createElementVNode("h1", {
          class: _normalizeClass(["main-logo mb-0", props.titleSize])
        }, "SEAI", 2)
      ]),
      _: 1
    })
  ]))
}
}

})